/**
 * True when the app is served from the Arizona subdomain.
 *
 * Computed synchronously: this used to resolve in a useEffect, so the first render always returned
 * false. Anything that seeds state from it (`useState(IsAzAccount())`) captured that false and
 * never saw the correction — the Retailers map, for one, never opened full screen for Arizona.
 */
const isAzSubdomain = () => {
  const { hostname } = window.location;
  const parts = hostname.split('.');
  if (parts.length > 2 || (parts.length === 2 && parts[0] !== 'localhost')) {
    return parts[0] === 'az';
  }
  return false;
};

function IsAzAccount() {
  return isAzSubdomain();
}

export { isAzSubdomain };
export default IsAzAccount;
